import styled from "styled-components";
import { Form } from "antd";
import ScreenHelper from "components/Styled/ScreenHelper";

//in use
export const CardInforFormStyle = styled(Form)`
    .cardInfo{
        text-align: left; 
        border: 1px lightgrey solid; 
        border-radius: 10px;
        margin-bottom: 10px; 
        padding: 10px;
        padding-left: 15px;
        padding-right: 15px;        

        ${ScreenHelper.down('md')`
            text-align: center;
            vertical-align: middle;
        `}
    }

    .cardDetails {
        ${ScreenHelper.up('lg')`
            // margin-top: 25px;
        `}
    }

    .cardLogo {
        height: 25%; 
        width: 50%;
        color: black;
        
        ${ScreenHelper.down('sm')`
            width: 75%;
        `} 
    }

    .cardAlignment{
        ${ScreenHelper.up('lg')`
            display: flex;
            align-items: center;
            justify-content: center;
        `} 
    }

`;